import { createContext } from "react"
import { EditorContextProps } from "./types"
import { EditorContextPropsBuilder } from "./EditorContextPropsBuilder"

const builder = new EditorContextPropsBuilder()
const defaultEditorContextProps = builder.build(true)

export const EditorContext = createContext<EditorContextProps>(defaultEditorContextProps)
